<div class="comment-container">
    <div class="comment-write">
        <app-tinymce-editor *ngIf="isEditorComment" [uploadPath]="uploadPath" [(editorContent)]="comment"></app-tinymce-editor>
        <textarea *ngIf="!isEditorComment" rows="4" nz-input [(ngModel)]="comment" trim="blur"></textarea>

        <div class="button-group">
            <button class="text-btn-danger" nz-button (click)="onCancel()" [disabled]="disabledCancel">Cancel</button>
            <button class="text-btn-primary" nz-button [nzLoading]="submitLoading" [disabled]="disabledSubmit" (click)="onSubmit()">Submit</button>
        </div>
    </div>
    <nz-spin [nzSpinning]="loading">
        <div class="comment-list">
            <div class="row" *ngFor="let item of data; let i = index">
                <div class="name-time">
                    <div class="name">{{ item.createdByName }}</div>
                    <div class="time">
                        {{ item.createdDate | date: 'YYYY-MM-dd HH:mm:ss' }}
                        <span *ngIf="item.createdDate !== item.lastModifiedDate">
                            (Edited: {{ item.lastModifiedDate | date: 'YYYY-MM-dd HH:mm:ss'}})
                        </span>
                    </div>
                </div>
                <div class="comment">
                    <ng-container *ngIf="!editRow || editRow?.id !== item.id; else editComment">
                        <quill-view class="remove-padding-quill" [content]="item.commentMessage" [sanitize]="true" format="html"></quill-view>
                    </ng-container>
                    <ng-template #editComment>
                        <app-tinymce-editor *ngIf="isEditorComment" [uploadPath]="uploadPath" [editorId]="'editor' + i" [(editorContent)]="item.commentMessage"></app-tinymce-editor>
                        <textarea *ngIf="!isEditorComment" rows="3" nz-input [(ngModel)]="item.commentMessage" trim="blur"></textarea>
                    </ng-template>
                </div>
                <div class="action-btn" *ngIf="editRow && editRow?.id === item.id; else notEditRow">
                    <button
                        nz-button
                        nzType="text"
                        nzDanger
                        (click)="cancelEdit(item)"
                    >Cancel</button>
                    <button
                        nz-button
                        nzType="text"
                        class="primary-btn"
                        (click)="handEdit(item)"
                    >Submit</button>
                </div>
                <ng-template #notEditRow>
                    <div class="action-btn" *ngIf="hasEditDeleteBtn">
                        <button
                            nz-button
                            nzType="text"
                            class="primary-btn"
                            (click)="edit(item)"
                            [disabled]="needDisabledEditDeleteBtn && !canEditDelete(item)"
                        >Edit</button>
                        <button
                            nz-button
                            nzType="text"
                            (click)="delete(item.id)"
                            [disabled]="needDisabledEditDeleteBtn && !canEditDelete(item)"
                            nzDanger
                        >Delete</button>
                    </div>
                </ng-template>
            </div>
        </div>
    </nz-spin>
</div>
